import Router from 'next/router'

import { Modal, ModalProps } from './Modal'

interface Props extends ModalProps {}

export const SignUpFlowModal = ({ isOpen, ...rest }: Props): JSX.Element => {
  return (
    <Modal
      isOpen={isOpen}
      customStyles={{
        content: {
          padding: '60px 50px 72px',
          width: '720px',
        },
      }}
      {...rest}
    >
      <h3 className="mb-[30px] text-center text-xl font-bold text-[#404040]">
        「サービス名」のお申し込み
      </h3>

      <div className="px-[15px] text-[17px] leading-[30px] tracking-[0.42px] text-[#666666]">
        アカウント登録後、専用アプリでログインいただくとすぐにサービスをご利用いただけます。
      </div>

      <div className="mt-[14px] bg-[#EDF6F8] px-[30px] pb-[22px] pt-[24px]">
        <div className="mb-4 text-center text-sm font-medium text-[#333333]">
          サービス開始までのステップ
        </div>
        <div className="my-auto flex flex-wrap justify-around">
          <div className="flex h-[81px] w-[124px] rounded-[4px] bg-white">
            <div className="relative block h-full w-[18px] min-w-[18px] rounded-l-[4px] bg-[#79CAD3] text-[15px] text-white">
              <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 font-bold">
                1
              </span>
            </div>
            <div className="flex pb-[11px] pl-[8px] pr-[6px] pt-[14px] text-left text-xs text-[#2DB9C4]">
              アカウントの登録メールアドレス認証
            </div>
          </div>
          <div className="mb-auto ml-1 mr-auto mt-auto h-[18px] w-[10px] border-b-[9px] border-l-[10px] border-r-0 border-t-[9px] border-solid border-b-transparent border-l-[#2DB9C4] border-r-transparent border-t-transparent" />
          <div className="flex h-[81px] w-[124px] rounded-[4px] bg-white">
            <div className="relative block h-full w-[18px] min-w-[18px] rounded-l-[4px] bg-[#79CAD3] text-[15px] text-white">
              <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 font-bold">
                2
              </span>
            </div>
            <div className="flex pb-[11px] pl-[8px] pr-[6px] pt-[14px] text-left text-xs text-[#2DB9C4]">
              料金プランの選択とお支払い
            </div>
          </div>
          <div className="mb-auto ml-1 mr-auto mt-auto h-[18px] w-[10px] border-b-[9px] border-l-[10px] border-r-0 border-t-[9px] border-solid border-b-transparent border-l-[#2DB9C4] border-r-transparent border-t-transparent" />
          <div className="flex h-[81px] w-[124px] rounded-[4px] bg-white">
            <div className="relative block h-full w-[18px] min-w-[18px] rounded-l-[4px] bg-[#79CAD3] text-[15px] text-white">
              <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 font-bold">
                3
              </span>
            </div>
            <div className="flex pb-[11px] pl-[8px] pr-[6px] pt-[14px] text-left text-xs text-[#2DB9C4]">
              アカウントの登録完了
            </div>
          </div>
          <div className="mb-auto ml-1 mr-auto mt-auto h-[18px] w-[10px] border-b-[9px] border-l-[10px] border-r-0 border-t-[9px] border-solid border-b-transparent border-l-[#2DB9C4] border-r-transparent border-t-transparent" />
          <div className="flex h-[81px] w-[124px] rounded-[4px] bg-white">
            <div className="relative block h-full w-[18px] min-w-[18px] rounded-l-[4px] bg-[#79CAD3] text-[15px] text-white">
              <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 font-bold">
                4
              </span>
            </div>
            <div className="flex pb-[11px] pl-[8px] pr-[6px] pt-[14px] text-left text-xs text-[#2DB9C4]">
              専用アプリでログイン
            </div>
          </div>
        </div>
      </div>

      <button
        className="g-button g-button--primary mx-auto mt-[37px] block w-[180px]"
        onClick={() => Router.push('/web/agreement')}
      >
        はじめる
      </button>
    </Modal>
  )
}
